
import React from 'react'

const ShoppingcartQuantityBadge = (props) => <div className={ `shoppingcart-quantity-badge ${ (props.units > 0) ? 'visible' : '' }` }>
  <p className="p bold white s13">{ props.units }</p>
</div>

export default ShoppingcartQuantityBadge
